export const defaultOptionsMap = {
    company: [
        { value: "", label: "Популярные" },
        { value: "price@asc", label: "Возрастанию цены" },
        { value: "price@desc", label: "Убыванию цены" }
    ]
};